module.exports = __webpack_public_path__ + "img/not-authorized.845c0603.svg";